import React, { FC } from 'react'
import IconComponent from 'app_components/commons/icons'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';

import './StudentHelpButton.scss'

const StudentHelpButton: FC = () => {
  return (
    <div className="student-help-button--layout">
      <IconComponent svg="Help" />
      <TextComponent color="white" fontWeight={600} fontSize="0.875rem">Tour guiado</TextComponent>
    </div>
  )
}

export default StudentHelpButton
